import React, { Fragment } from "react";
import PropTypes from "prop-types";
import loader from './Loader-1.gif'
import "./Loader.css";

const Loader = ({ isLoading = false, text="" }) => {
    return (
        <Fragment>
            {isLoading && (
                <div className="loader-wrapper">
                    <img
                        className="loader-img"
                        src={loader}
                        alt="Loading..."
                    />
                    {!!text && (
                        < div className="loader-text"  >{text}</div>
                    )}
                </div>
            )}
        </Fragment>
    );
};

Loader.propTypes = {
    isLoading: PropTypes.bool,
};

export default Loader;
